export const apiEndPoints = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    bodygraph: '/auth/bodygraph',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    verifyOtp: '/auth/verify-otp',
    verifyEmail: '/auth/verify',
    emailOtp: '/auth/genarate-email-otp',
  },
  profile: {
    profile: '/profile',
    editProfile: '/edit-profile',
    changePassword: '/change-password',
  },

  chatPrompt: {
    chat: '/chat/message',
    history: '/chat/history',
    historyDetails: '/chat/history-details',
    historyDelete: '/chat/history-delete',
  },
  admin: {
    users: {
      list: '/admin/users',
      delete: '/admin/users',
      upgrade: '/admin/users/upgrade',
      free: '/admin/users/free'
    },
    types: {
      types: 'types',
      typeEdit: 'types/type'
    },
    general: {
      general: 'general',
    },
    humanDesign: {
      humanDesign: 'human-design',
      
    },
    promptSuggesstions: {
      suggesstions: 'chat/prompt-suggestions',
    },
    createSubadmin: {
      create: '/admin/create-subadmin'
    }
  },
  plans: {
      get: '/admin/plan',
      getById: '/admin/plan',
      create: '/admin/plan',
      update: '/admin/plan',
      delete: '/admin/plan',
      updatefree: '/admin/plan/free',
      fetchfree: '/admin/plan/free',
  },
  Userplans: {
      get: '/user/plans',
      
  },
  payment: {
      get: '/payment/method',
      create: '/payment/method',
      checkout: '/payment/checkout',
      canclelation:'/payment/cancelation',
      upcoming: '/payment/upcoming'
  },
  transaction: {
      fetch: '/admin/transactions',
      
  }
};
